/// <reference path="../../../typings/tsd.d.ts" /> 
/// <reference path="../../../typings/linq/linq.d.ts" />
module warsApp.models {

    declare var menuConfigurationModelSelf: MenuConfigurationModel;

    export class MenuLinkDto {
        Id: string;
        ContentPageId: string;
        ProcessTypeId: string;
        MenuItemId: string;
        Name: string;
        IsSeparator: boolean;
        Order: number;
        SecurityMatrixId: string;
    }

    export class MenuItemDto {
        Id: string;
        Name: string;
        IsPublished: boolean;
        DefaultUrl: string;
        Order: number;
    }

    export class ProcessEventDto {
        Id: string;
        ProcessEventConfigUniqueId: string;
        NotificationType: string;
        Comment: string;
        CreatedUser: string;
        CreatedDate: Date;
        DocumentIds: Array<string>;
    }

    export class MenuConfigurationModel {
        public editModelItem: boolean;
        public menuItems: Wars.Domain.Model.Dtos.MenuItemDto[] = [];
        public selectedMenuItem: Wars.Domain.Model.Dtos.MenuItemDto;
        public contentPageDtos: Wars.Domain.Model.Dtos.ContentPageDto[];
        public activeProcessTypes: Wars.Domain.Model.ProcessType[];
        public contentPages: any;

        constructor(
            private menuItemService: services.MenuItemService,
            private menuLinkService: services.MenuLinkService,
            private contentPageService: services.ContentPageService,
            private securityMatrixService: services.SecurityMatrixService,
            private processTypeService: services.ProcessTypeService) {
            menuConfigurationModelSelf = this;

            menuConfigurationModelSelf.menuItemService.getMenuItems().then(r => {
                menuConfigurationModelSelf.menuItems = r;
            });

            menuConfigurationModelSelf.contentPageService.getContentPagesForConfiguration()
                .then(pages => {
                    menuConfigurationModelSelf.contentPageDtos = pages;
                });

            menuConfigurationModelSelf.processTypeService.getActiveProcessTypes().then(result => {
                menuConfigurationModelSelf.activeProcessTypes = result;
            });
        }

        public removeLink(link: Wars.Domain.Model.Dtos.MenuLinkDto) {
            menuConfigurationModelSelf.menuLinkService.deleteMenuLink(link)
                .then(() => {
                    menuConfigurationModelSelf.selectedMenuItem.menuLinkDtos.remove(link);
                });
        }

        public removeMenuItem(item: Wars.Domain.Model.Dtos.MenuItemDto) {
            menuConfigurationModelSelf.menuItemService.deleteMenuItem(item)
                .then(() => {
                    menuConfigurationModelSelf.menuItems.remove(item);
                });
        }

        public addMenuItem() {
            var menuItemDto = new MenuItemDto();
            menuItemDto.Name = "Menu Item";
            menuItemDto.IsPublished = false;
            menuItemDto.Order = menuConfigurationModelSelf.menuItems.length + 1;

            menuConfigurationModelSelf.menuItemService.addMenuItem(menuItemDto)
                .then((menuItem) => {
                    menuConfigurationModelSelf.menuItems.push(menuItem);
                });
        }

        public updateMenuItem(menuItem: Wars.Domain.Model.Dtos.MenuItemDto) {
            menuConfigurationModelSelf.menuItemService.updateMenuItem(menuItem);
        }

        public sortMenuItems($item: Wars.Domain.Model.Dtos.MenuItemDto, $partFrom: Wars.Domain.Model.Dtos.MenuItemDto[], $partTo, $indexFrom, $indexTo, $modal) {
            var arrayCopy = Enumerable.from($partFrom).orderBy(z => z.order).toArray();

            var spliced = arrayCopy.splice($indexFrom, 1);
            arrayCopy.splice($indexTo, 0, spliced[0]);

            $item.order = $indexTo;

            for (var i = 0; i < $partFrom.length; i++) {
                var numberId = $partFrom[i].id;
                $partFrom[i].order = Enumerable.from(arrayCopy).indexOf(i => i.id == numberId);
            }

            menuConfigurationModelSelf.menuItemService.updateMenuItems(menuConfigurationModelSelf.menuItems);
        }

        public select(item: Wars.Domain.Model.Dtos.MenuItemDto) {
            menuConfigurationModelSelf.selectedMenuItem = item;
            menuConfigurationModelSelf.selectedMenuItem.menuLinkDtos.forEach(i => {
                //i.se
            });
        }

        public addSeparator() {
            var menuLinkDto = new MenuLinkDto();
            menuLinkDto.Name = "";
            menuLinkDto.IsSeparator = true;
            menuLinkDto.Order = menuConfigurationModelSelf.selectedMenuItem.menuLinkDtos.length + 1;
            menuLinkDto.MenuItemId = menuConfigurationModelSelf.selectedMenuItem.id;
            menuConfigurationModelSelf.menuLinkService.addMenuLink(menuLinkDto)
                .then((menuLink) => {
                    menuConfigurationModelSelf.selectedMenuItem.menuLinkDtos.push(menuLink);
                });
        }

        public addLink() {
            var securityMatrix = menuConfigurationModelSelf.securityMatrixService.createSecurityRow(true);
            var menuLinkDto = new MenuLinkDto();
            menuLinkDto.Name = "New Link";
            menuLinkDto.IsSeparator = false;
            menuLinkDto.Order = menuConfigurationModelSelf.selectedMenuItem.menuLinkDtos.length + 1;
            menuLinkDto.MenuItemId = menuConfigurationModelSelf.selectedMenuItem.id;
            menuLinkDto.SecurityMatrixId = securityMatrix.id;
            menuConfigurationModelSelf.securityMatrixService.saveAllChanges(() => {
                menuConfigurationModelSelf.menuLinkService.addMenuLink(menuLinkDto)
                    .then((menuLink) => {
                        menuConfigurationModelSelf.selectedMenuItem.menuLinkDtos.push(menuLink);
                    });
            });
        }

        public updateMenuLink(menuLink: Wars.Domain.Model.Dtos.MenuLinkDto) {
            menuConfigurationModelSelf.menuLinkService.updateMenuLink(menuLink);
        }

        public sortLinks($item: Wars.Domain.Model.Dtos.MenuLinkDto, $partFrom: Wars.Domain.Model.Dtos.MenuLinkDto[], $partTo, $indexFrom, $indexTo, $modal) {
            var arrayCopy = Enumerable.from($partFrom).orderBy(z => z.order).toArray();

            var spliced = arrayCopy.splice($indexFrom, 1);
            arrayCopy.splice($indexTo, 0, spliced[0]);

            $item.order = $indexTo;

            for (var i = 0; i < $partFrom.length; i++) {
                var numberId = $partFrom[i].id;
                $partFrom[i].order = Enumerable.from(arrayCopy).indexOf(i => i.id == numberId);
            }

            menuConfigurationModelSelf.menuLinkService.updateMenuLinks(menuConfigurationModelSelf.selectedMenuItem.menuLinkDtos);
        }

        public openSecurityMatrixModal(link: Wars.Domain.Model.Dtos.MenuLinkDto) {
            menuConfigurationModelSelf.securityMatrixService.fetchById(link.securityMatrixId, "SecurityMatrix")
                .then((securityMatrix) => {
                    menuConfigurationModelSelf.securityMatrixService.openSecurityMatrixModal(securityMatrix, undefined);
                });
        }
    }
}